import CollapsibleGroupComponent from '../../stories/molecules/collapsible-group/index.jsx'
import { FolderContentContainer } from '../../stories/organisms/top-navigation/styled-components.js'
import {
  ChevronRightSmall,
  Confirm
} from '../../stories/atoms/icons/essentials/index.js'
import RecursiveListFetcher from './recursive-list-fetcher.jsx'
import { Folder } from '../../stories/atoms/icons/entities/index.js'
import {
  ConfirmIconContainer,
  RecursiveListItem
} from '../styled-components.js'
import ButtonComponent from '../../stories/atoms/button/index.jsx'
import {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions
} from '../../stories/atoms/button/constants.js'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { iconSizeOptions } from '../../stories/atoms/icons/icons-sizes.js'

export const RecursiveListNode = ({
  item,
  search = '',
  selectedItem,
  setSelectedItem,
  listType,
  projectId
}) => {
  const hasChildren = item?.items > 0
  const paddingLeftForChildrenItems = !hasChildren ? '2.5rem' : '0px'
  const isSelectedItem = item.id === selectedItem?.id

  const [collapsibleIsOpen, setCollapsibleIsOpen] = useState(false)

  const handleToggleCollapsibleItem = () => {
    setCollapsibleIsOpen(!collapsibleIsOpen)
  }

  const handleSelectItem = () => {
    if (isSelectedItem) return setSelectedItem(null)

    return setSelectedItem(item)
  }

  const rightIcon = isSelectedItem ? (
    <ConfirmIconContainer>
      <Confirm size={iconSizeOptions['ICON-S']} />
    </ConfirmIconContainer>
  ) : null

  const handleChevronClick = (e) => {
    e.stopPropagation()
    handleToggleCollapsibleItem()
  }

  const chevronLeftIcon = (
    <ButtonComponent
      size={buttonSizeOptions.SMALL}
      variant={buttonVariantOptions.GHOST}
      buttonType={buttonTypeOptions['ICON-ONLY']}
      onClick={handleChevronClick}
    >
      <ChevronRightSmall />
    </ButtonComponent>
  )

  return (
    <RecursiveListItem>
      <CollapsibleGroupComponent.Item
        key={item.id}
        id={item.id}
        isOpen={collapsibleIsOpen}
        title={item.name}
        borderBottom={false}
        showChevronLeft={hasChildren}
        chevronLeftIcon={chevronLeftIcon}
        leftIcon={<Folder />}
        activeWhenOpen
        disabled={!item.active}
        style={{
          padding: '0px',
          paddingLeft: paddingLeftForChildrenItems,
          minHeight: '32px'
        }}
        rightIcon={rightIcon}
        onClick={handleSelectItem}
        isSelected={isSelectedItem}
      >
        {hasChildren && (
          <FolderContentContainer>
            <RecursiveListFetcher
              folderId={item.id}
              projectId={projectId}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              search={search}
              listType={listType}
            />
          </FolderContentContainer>
        )}
      </CollapsibleGroupComponent.Item>
    </RecursiveListItem>
  )
}

RecursiveListNode.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.number
  }),
  search: PropTypes.string,
  selectedItem: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.number
  }),
  setSelectedItem: PropTypes.func,
  listType: PropTypes.string,
  projectId: PropTypes.string
}

export default RecursiveListNode
